module.exports = __webpack_public_path__ + "media/images/emblems/Laupen-coat_of_arms-824f2a621a6586866118542c8283991c.svg";